export interface TileOption {
  value: string;
  label: string;
  group: string;
  type: "data" | "visualization";
}

export const TILE_OPTIONS: TileOption[] = [
  // Visualizations
  {
    value: "StrikeZone",
    label: "Strike Zone",
    group: "Visualizations",
    type: "visualization",
  },
  {
    value: "Landing",
    label: "Landing Point",
    group: "Visualizations",
    type: "visualization",
  },
  {
    value: "Contact",
    label: "Contact Point",
    group: "Visualizations",
    type: "visualization",
  },

  // Pitching Options
  {
    value: "Velocity",
    label: "Velocity",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Spin Rate",
    label: "Spin Rate",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Efficiency",
    label: "Efficiency",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Tilt",
    label: "Tilt",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Spin Axis",
    label: "Spin Axis",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Vert Break",
    label: "Vert Break",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "I. Vert Break",
    label: "I. Vert Break",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Horz Break",
    label: "Horz Break",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Vert Apr Angle",
    label: "Vert Apr Angle",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Horz Apr Angle",
    label: "Horz Apr Angle",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Rel Height",
    label: "Rel Height",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Rel Side",
    label: "Rel Side",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Extension",
    label: "Extension",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Zone Velo",
    label: "Zone Velo",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Plate Ht.",
    label: "Plate Location Height",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Plate Side",
    label: "Plate Location Side",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "Zone Time",
    label: "Zone Time",
    group: "Pitching Options",
    type: "data",
  },
  {
    value: "FSRI",
    label: "FSRI",
    group: "Pitching Options",
    type: "data",
  },

  // Hitting Options
  {
    value: "Exit Velo",
    label: "Exit Velo",
    group: "Hitting Options",
    type: "data",
  },
  {
    value: "Launch Angle",
    label: "Launch Angle",
    group: "Hitting Options",
    type: "data",
  },
  {
    value: "Distance",
    label: "Projected Distance",
    group: "Hitting Options",
    type: "data",
  },
  {
    value: "Direction",
    label: "Direction",
    group: "Hitting Options",
    type: "data",
  },
  {
    value: "Hang Time",
    label: "Hang Time",
    group: "Hitting Options",
    type: "data",
  },
  {
    value: "Batd Spin Rate",
    label: "Batd Spin Rate",
    group: "Hitting Options",
    type: "data",
  },
  {
    value: "Bearing",
    label: "Bearing",
    group: "Hitting Options",
    type: "data",
  },
];
